module.exports = __webpack_public_path__ + "static/media/生日.62184673.png";